import React from "react";

import styles from "./NormalButton.module.scss";

const NormalButton = ({ label, onClick = () => {}, disabled = false }) => {
  return (
    <button
      className={styles.normal_btn}
      onClick={() => onClick()}
      disabled={disabled}
    >
      <span>{label}</span>
    </button>
  );
};

export default NormalButton;
